import { configureStore } from '@reduxjs/toolkit';
import languageReducer from './languageSlice';
import calendarDateReducer from './calendarDateSlice';
import authReducer from './authSlice';

export default configureStore({
    reducer: {
        language: languageReducer,
        calendardate: calendarDateReducer,
        auth: authReducer,
    },
})